<p>
    Application is loading. Please wait...
</p>